// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"5983":"css/app.6732","9895":"css/admin-app.6732"}[chunkId] + ".css";
};